module.exports = __webpack_public_path__ + "static/img/section_02_pedalboard_paradise_kv_mobile.96b1c37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/overview/section_02_pedalboard_paradise_kv_mobile.png
// module id = EPAy
// module chunks = 12